import Instance from '../../../Axios';

const AdicionarUtilizador = (ydata) => async (dispatch) => {
  console.log(ydata);
  await Instance()
    .post('/backend/utilizadores', { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_UTILIZADOR', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
        console.log(err);
      }
    });
};

export default AdicionarUtilizador;
